import {PRODUCTION, STAGING} from './environments';

export interface Flags {
  BCA: boolean;
  BLOG_SEARCH: boolean;
  BUSINESS_LOAN_CALCULATOR: boolean;
  CONFIGURABLE_LANGUAGE: boolean;
  CONNECT_V2: boolean;
  DASHBOARD_ALL_APPLICATIONS: boolean;
  KNOWLEDGE_HUB_SEARCH: boolean;
  MAILCHIMP_FORM: boolean;
  NL_DASHBOARD: boolean;
  PARTNERS_PAGES_NL: boolean;
  PARTNERS_USE_FORM: boolean;
  PRESS_PAGE: boolean;
  QUOTE_FORM_ADDITIONAL_QUESTIONS: boolean;
  QUOTE_FORM_DIRECTORS_PAGE: boolean;
  QUOTE_FORM_DOC_UPLOAD: boolean;
  QUOTE_FORM_DRAFTS: boolean;
  QUOTE_FORM_OPEN_BANKING_PAGE: boolean;
  QUOTE_FORM_PAGE_GENERATION: boolean;
  QUOTE_FORM_PROPERTY_IS_KNOWN_ADDRESS: boolean;
  QUOTE_FORM_PARTIAL_APPLICATIONS: boolean;
  SEND_VERIFY_EMAIL: boolean;
  SHOW_NUMBER_MATCHES: boolean;
}

const flags: Flags = {
  BCA: process.env.STAGE !== PRODUCTION,
  BLOG_SEARCH: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  BUSINESS_LOAN_CALCULATOR: true,
  CONFIGURABLE_LANGUAGE: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  CONNECT_V2: process.env.STAGE !== PRODUCTION,
  DASHBOARD_ALL_APPLICATIONS: process.env.STAGE !== PRODUCTION,
  KNOWLEDGE_HUB_SEARCH: false,
  MAILCHIMP_FORM: true,
  NL_DASHBOARD: true,
  PARTNERS_PAGES_NL: process.env.STAGE !== PRODUCTION,
  PARTNERS_USE_FORM: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  PRESS_PAGE: process.env.STAGE !== PRODUCTION,
  QUOTE_FORM_ADDITIONAL_QUESTIONS: process.env.STAGE !== PRODUCTION,
  QUOTE_FORM_DIRECTORS_PAGE: process.env.STAGE !== PRODUCTION,
  QUOTE_FORM_DOC_UPLOAD: process.env.STAGE !== PRODUCTION,
  QUOTE_FORM_DRAFTS: true,
  QUOTE_FORM_OPEN_BANKING_PAGE: true,
  QUOTE_FORM_PAGE_GENERATION: true,
  QUOTE_FORM_PROPERTY_IS_KNOWN_ADDRESS: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
  QUOTE_FORM_PARTIAL_APPLICATIONS: process.env.STAGE !== PRODUCTION,
  SEND_VERIFY_EMAIL: false,
  SHOW_NUMBER_MATCHES: process.env.STAGE !== PRODUCTION && process.env.STAGE !== STAGING,
};

export default flags;
